import { experimentRepository } from "./experiment/experimentRepository";
import { snapshotsRepository } from "./snapshots/snapshotsRepository";
export const exact3Repository = {
    experiment: experimentRepository,
    snapshots: snapshotsRepository
};
